/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { RasterRainUnitsEnum } from "./RasterRainUnitsEnum";
import {
  RasterRainUnitsEnumFromJSON,
  RasterRainUnitsEnumFromJSONTyped,
  RasterRainUnitsEnumToJSON,
  RasterRainUnitsEnumToJSONTyped,
} from "./RasterRainUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface NetCDFRasterRain
 */
export interface NetCDFRasterRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number | null;
  /**
   * Duration of event in seconds
   */
  duration?: number | null;
  /**
   * in simulation in seconds
   */
  timestamps?: Array<number> | null;
  /**
   * interval in seconds
   */
  interval?: number | null;
  /**
   *
   */
  valuesReference?: string | null;
  /**
   *
   */
  fillValue?: string;
  /**
   *
   */
  units?: RasterRainUnitsEnum | null;
  /**
   *
   */
  geotransform?: Array<number>;
  /**
   *
   */
  epsgCode?: number;
  /**
   *
   */
  file?: FileReadOnly;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the NetCDFRasterRain interface.
 */
export function instanceOfNetCDFRasterRain(value: object): value is NetCDFRasterRain {
  return true;
}

export function NetCDFRasterRainFromJSON(json: any): NetCDFRasterRain {
  return NetCDFRasterRainFromJSONTyped(json, false);
}

export function NetCDFRasterRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NetCDFRasterRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    timestamps:
      json["timestamps"] === undefined
        ? undefined
        : json["timestamps"] === null
        ? null
        : json["timestamps"],
    interval:
      json["interval"] === undefined
        ? undefined
        : json["interval"] === null
        ? null
        : json["interval"],
    valuesReference:
      json["values_reference"] === undefined
        ? undefined
        : json["values_reference"] === null
        ? null
        : json["values_reference"],
    fillValue: json["fill_value"] == null ? undefined : json["fill_value"],
    units:
      json["units"] === undefined
        ? undefined
        : json["units"] === null
        ? null
        : RasterRainUnitsEnumFromJSON(json["units"]),
    geotransform: json["geotransform"] == null ? undefined : json["geotransform"],
    epsgCode: json["epsg_code"] == null ? undefined : json["epsg_code"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function NetCDFRasterRainToJSON(json: any): NetCDFRasterRain {
  return NetCDFRasterRainToJSONTyped(json, false);
}

export function NetCDFRasterRainToJSONTyped(
  value?: Omit<NetCDFRasterRain, "url" | "simulation" | "uid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    multiplier: value["multiplier"],
    offset: value["offset"],
    duration: value["duration"],
    timestamps: value["timestamps"],
    interval: value["interval"],
    values_reference: value["valuesReference"],
    fill_value: value["fillValue"],
    units: RasterRainUnitsEnumToJSON(value["units"]),
    geotransform: value["geotransform"],
    epsg_code: value["epsgCode"],
    file: FileReadOnlyToJSON(value["file"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
